import React from "react";

function WhatIsWeb3W() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is a Web3 Wallet ?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  A Web3 wallet is a decentralized digital wallet that allows
                  users to securely store, manage, and interact with
                  cryptocurrencies, tokens, and decentralized applications
                  (dApps) on blockchain networks. Unlike traditional wallets,
                  Web3 wallets give users full control over their private keys,
                  enabling them to participate in decentralized finance (DeFi),
                  non-fungible tokens (NFTs), and other blockchain-based
                  ecosystems without relying on intermediaries.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WhatIsWeb3W;
